export default function ProgressBar({ sales, index }) {
    const label = sales.label[index]
    const data = sales.data[index]
    const salesCommission = {
        label: sales.label[sales.label.length - 1],
        data: sales.data[sales.data.length - 1]
    };

    let progress = (salesCommission.data / data) * 100;
    progress = progress > 100 ? 100 : progress

    const colors = [
        '#EF476F',
        '#FFD166',
        '#06D6A0',
        '#118AB2',
        '#073B4C'
    ];

    return <>
        <div>
            <div className='flex justify-between items-center mb-1'>
                <p className='md:text-xs text-[10px] font-medium text-gray-two'>
                    { label }
                    {
                        label !== 'Sales Commission' ?
                        <>
                            {''} Annual Trip Target >
                            {''} <span className='md:text-sm text-xs text-gray-one font-semibold'>
                                RM { data.toLocaleString() }
                            </span>
                        </> : ''
                    }
                </p>
            </div>
            
            <div className='h-3 w-full bg-gray-300 rounded-full overflow-hidden'>
                <div
                    className='h-full'
                    style={{
                        width: `${ progress }%`,
                        backgroundColor: label !== 'Sales Commission' ? `${ colors[index] }` : '#6366f1'
                    }}
                />
            </div>
        </div>
    </>
}